import { TOKEN_LOCALSTORAGE_KEY } from "@/shared/const";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { AuthState, User } from "./authTypes";

const initialState: AuthState = {
  user: null,
  token: localStorage.getItem(TOKEN_LOCALSTORAGE_KEY),
  isAuthenticated: !!localStorage.getItem(TOKEN_LOCALSTORAGE_KEY),
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setCredentials: (
      state,
      action: PayloadAction<{ user: User; token: string }>,
    ) => {
      state.user = action.payload.user;
      state.token = action.payload.token;
      state.isAuthenticated = true;
      localStorage.setItem(TOKEN_LOCALSTORAGE_KEY, action.payload.token);
    },
    logout: (state) => {
      state.user = null;
      state.token = null;
      state.isAuthenticated = false;
      localStorage.removeItem(TOKEN_LOCALSTORAGE_KEY);
    },
  },
});

export const { setCredentials, logout } = authSlice.actions;
export const authReducer = authSlice.reducer;
